module.exports = __webpack_public_path__ + "assets/app-store.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/app-store.svg
// module id = 428
// module chunks = 17